import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { inputCls, labelCls } from "./shared";

export default function AnnouncementsTab() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");

  const load = useCallback(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch((e) => console.error("Falha ao carregar avisos:", e));
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/announcements", { text });
      toast.success("Aviso publicado para todos os participantes");
      setText("");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <form onSubmit={add} className="card-metric space-y-3">
        <label className={labelCls}>Novo aviso para os participantes</label>
        <textarea required value={text} onChange={(e) => setText(e.target.value)} rows={3}
          className={inputCls} placeholder="Ex: A palestra de abertura começa em 10 minutos na Plenária Principal!"
          data-testid="admin-announcement-input" />
        <button type="submit" className="btn-primary" data-testid="admin-publish-announcement-btn">Publicar aviso</button>
      </form>
      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} className="card-metric flex items-start justify-between gap-3" data-testid={`announcement-${a.id}`}>
            <div>
              <p className="text-sm text-slate-200">{a.text}</p>
              <p className="text-[10px] text-slate-500 font-data mt-1">{new Date(a.created_at).toLocaleString("pt-BR")}</p>
            </div>
            <button onClick={async () => { await api.delete(`/admin/announcements/${a.id}`); load(); }}
              className="p-1.5 text-red-400 hover:bg-red-500/10 rounded shrink-0" data-testid={`delete-announcement-${a.id}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        {items.length === 0 && <p className="text-sm text-slate-500">Nenhum aviso publicado.</p>}
      </div>
    </div>
  );
}
